/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N700 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { gridSize } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

import { LEFT_SPACING, VERTICAL_SPACING } from '../../../../../common/ui/side-container/styled';

const BACK_HEIGHT = gridSize() * 4;
const BACK_BOTTOM = gridSize();
const FOOTER_HEIGHT = gridSize() * 4;
const FOOTER_TOP = gridSize() * 3;
const FOOTER_BOTTOM = gridSize() / 4;

const SHIFT_FREQUENCY_MARGIN = gridSize();
const SHIFT_PERIOD_MARGIN = gridSize() / 2;

// FIX: used for hidden select popups
const BOTTOM_BUFFER = gridSize() * 4;

const HEIGHT_EXPECT_INNER =
	FOOTER_TOP + FOOTER_BOTTOM + FOOTER_HEIGHT + BACK_HEIGHT + BACK_BOTTOM + BOTTOM_BUFFER;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Timings = styled.h3({
	margin: `${token('space.250', '20px')} 0 ${token('space.100', '8px')} 0`,
});

// NOTE: overflow hidden added to prevent resize on loading spinner rotation
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Footer = styled.div({
	columnGap: token('space.100', '8px'),
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${FOOTER_TOP}px 0 ${FOOTER_BOTTOM}px 0`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${FOOTER_HEIGHT}px`,
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Scrollable = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `calc(100% - ${HEIGHT_EXPECT_INNER}px)`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	margin: `0 -${VERTICAL_SPACING / 2}px 0 -${LEFT_SPACING}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 ${VERTICAL_SPACING / 4}px ${BOTTOM_BUFFER}px ${LEFT_SPACING}px`,
	overflowY: 'auto',
});

// TODO: do not use role="radiogroup"
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Group = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"div[role='radiogroup']": {
		display: 'flex',
		columnGap: token('space.300', '24px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Shift = styled.div({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& >': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&:nth-child(1)': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			width: `calc(50% - ${SHIFT_FREQUENCY_MARGIN / 2}px)`,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			margin: `0 ${SHIFT_FREQUENCY_MARGIN}px 0 0`,
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ShiftDetails = styled.div({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `calc(50% - ${SHIFT_FREQUENCY_MARGIN / 2 + SHIFT_PERIOD_MARGIN / 2}px)`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& >': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&:nth-child(1)': {
			minWidth: token('space.500', '40px'),
			maxWidth: token('space.500', '40px'),
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			margin: `0 ${SHIFT_PERIOD_MARGIN}px 0 0`,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'&:nth-child(2)': {
			flex: '1 1 auto',
			margin: 0,
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Info = styled.p({
	margin: `${token('space.025', '2px')} 0 0 0`,
	color: token('color.text.subtlest', N700),
	font: token('font.body.small'),
	fontWeight: token('font.weight.regular'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MessageContainer = styled.div({
	margin: `${token('space.050', '4px')} 0 0 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NumberContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	"input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, input[type='number']": {
		WebkitAppearance: 'none',
		MozAppearance: 'textfield',
	},
});
